import React from 'react';
import PropTypes from 'prop-types';
import HandshakeIcon from './icons/HandshakeIcon';

HeroCard.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.node,
  body: PropTypes.node
};

export default function HeroCard(props) {
  const {
    icon,
    title = 'Card title',
    body = 'Card body copy.'
  } = props;

  const Icon = icon ?? HandshakeIcon;

  return (
    <div className="w-full h-full bg-white rounded-cs-10 shadow-lg p-4 flex flex-col">
      <div className="size-12 rounded-full bg-cs-orange-500 flex items-center justify-center text-white shrink-0">
        <Icon className="size-6" />
      </div>
      <h3 className="mt-3 font-semibold text-xl leading-tight text-black">{title}</h3>
      <p className="mt-3 font-normal text-base leading-tight text-cs-gray-500">{body}</p>
    </div>
  );
}
